import { useContext } from 'react';

import { ClaimRelationshipContext, ClaimRelationshipDispatchContext } from './Provider';

export const useClaimRelationshipDispatch = () =>
  useContext(ClaimRelationshipDispatchContext);

export const useClaimRelationshipState = () =>
  useContext(ClaimRelationshipContext);
